import React, { Component } from 'react';

import styles from './styles.scss';
import cn from 'classnames';

import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { createCollection } from 'actions/collections';
import { withTranslation } from 'react-i18next';

class CollectionsPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newCollectionName: ''
    };
  }

  handleChange = (e) => {
    this.setState({
      newCollectionName: e.target.value
    });
  }

  handleAddCollectionClick = (e) => {
    e.preventDefault();
    this.props.createCollection({
      // userUid: this.props.userUid,
      name: this.state.newCollectionName
    });
    this.props.setPopUp();
  }

  render() {
    const { t } = this.props;
    return (
      <div className={styles.PopUpOuter}>
        <div className={styles.PopUpInner}>
          <div className={styles.PopupContent}>
            <div className={styles.PopupTitle}>
              {t('components.collectionsPopup.title')}
            </div>
            <div className={styles.PopupBody}>
              <div className={styles.CreateCollectionForm}>
                <form onSubmit={this.handleAddCollectionClick}>
                  <input
                    type="text"
                    className={styles.CreateCollectionInput}
                    placeholder={t('components.collectionsPopup.enter')}
                    onChange={this.handleChange}
                  />
                  <input
                    type="submit"
                    className={cn(styles.CreateCollectionButton, 'button-primary', 'button-primary--md')}
                    disabled={this.state.newCollectionName === ''}
                    value={t('components.collectionsPopup.add')}
                  />
                </form>
              </div>
              {/* <p className={styles.PopupText}>Создавайте подборки для клиентов</p> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    userUid: state.profile.hash
  }),
  { setPopUp, createCollection }
)(withTranslation()(CollectionsPopup));



// WEBPACK FOOTER //
// ./src/components/CollectionsPopup/CollectionsPopup.js